import { Component } from '@angular/core';
import { VaccinationsComponent } from '@modules/cy/patient/euvac/components/vaccinations/vaccinations.component';

@Component({
  selector: 'ncp-vaccinations-card',
  imports: [VaccinationsComponent],
  templateUrl: './vaccinations-card.component.html',
  styleUrl: './vaccinations-card.component.scss',
})
export class VaccinationsCardComponent {}
